import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RegEntityDocumentPreviewModalComponent } from '../components/modals/document-preview-modal/document-preview-modal.component';
import { FULLSCREEN_PREVIEW_MODAL_CONFIG } from './fullscreen-preview-modal.config';

export interface RegEntityDocumentPreviewConfig {
  fileKey: string;
  fileName: string;
}

@Injectable({
  providedIn: 'root'
})
export class RegEntityDocumentPreviewManager {

  constructor(private modalService: NzModalService) { }

  /**
   * Open attachment preview modal
   */
  openPreview(config: RegEntityDocumentPreviewConfig): void {
    const modalRef = this.modalService.create({
      ...FULLSCREEN_PREVIEW_MODAL_CONFIG,
      nzContent: RegEntityDocumentPreviewModalComponent,
      nzWrapClassName: 'attachment-preview-modal-wrapper'
    });

    // Set input parameters after modal is created
    const componentInstance = modalRef.getContentComponent();
    componentInstance.fileKey = config.fileKey;
    componentInstance.fileName = config.fileName;
  }
}
